export default "__VITE_ASSET__DwCTFPqP__"